import { render, staticRenderFns } from "./barriergatelist.vue?vue&type=template&id=c4fd3078&scoped=true&"
import script from "./barriergatelist.vue?vue&type=script&lang=js&"
export * from "./barriergatelist.vue?vue&type=script&lang=js&"
import style0 from "./barriergatelist.vue?vue&type=style&index=0&id=c4fd3078&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4fd3078",
  null
  
)

export default component.exports